export default class APICallError extends Error {
    constructor(message, data) {
        super(message);
        for (let key in data) {
            this[key] = data[key];
        }
    }
}
